import * as React from 'react';
var PanelContext = /*#__PURE__*/React.createContext({});
export default PanelContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/PanelContext.js
// module id = 29
// module chunks = 0